import { render, staticRenderFns } from "./site_sx_list.vue?vue&type=template&id=67397fb4&scoped=true&"
import script from "./site_sx_list.vue?vue&type=script&lang=js&"
export * from "./site_sx_list.vue?vue&type=script&lang=js&"
import style0 from "./site_sx_list.vue?vue&type=style&index=0&id=67397fb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67397fb4",
  null
  
)

export default component.exports